<template>
  <div>
    <Form
      page-title="Edit Table"
      buttonName="Update"
      :branchId="branchId"
      :floorId="floorId"
      :businessId="businessId"
      :isInList="isInList"
      :model="model"
      @showAddChanged="$emit('showAddChanged', $event)"
      @submit="submit"
      :loading="loading"
    />
  </div>
</template>
<script>
import Form from "./Form";
import { updateTable } from "@/API/TablesAPIs";
import { submitAndNotify } from "@/helpers/utils";
export default {
  name: "Edit",
  components: { Form },
  props: ["isInList", "model", "businessId", "showAdd", "branchId", "floorId"],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    submit(formData) {
      const callback = () => {
        this.$emit("onSubmit");
        this.$emit("showAddChanged", !this.showAdd);
      };
      submitAndNotify(this, updateTable(formData), callback);
    }
  }
};
</script>
<style></style>
